<nz-collapse nzGhost>
  <nz-collapse-panel
    nzCollapsible="icon"
    [nzHeader]="'general.title' | translate"
    [nzActive]="active"
    [nzCollapsible]="disabled ? 'disabled' : undefined"
  >
    <!-- Name -->
    <nz-form-item>
      <nz-form-label
        class="quali-form-label"
        nzNoColon
        [nzRequired]="nameFormControl.hasValidator(Validators.required)"
      >
        {{ 'general.name' | translate }}
      </nz-form-label>
      <nz-form-control [nzValidateStatus]="nameFormControl" nzHasFeedback>
        <input
          nz-input
          [formControl]="nameFormControl"
          [placeholder]="
            hasMixedValues.name
              ? ('general.mixed' | translate)
              : ('general.name' | translate)
          "
        />
      </nz-form-control>
    </nz-form-item>

    <!-- Label -->
    @let labels = labels$ | async;
    <nz-form-item>
      <nz-form-label class="quali-form-label" nzNoColon>
        {{ 'labels.title' | translate }}
      </nz-form-label>
      <nz-form-control [nzValidateStatus]="labelFormControl" nzHasFeedback>
        <nz-select
          [formControl]="labelFormControl"
          [nzMode]="'multiple'"
          [nzPlaceHolder]="'labels.title' | translate"
          [nzAllowClear]="true"
          [nzShowArrow]="true"
          [nzCustomTemplate]="selectedLabelsTemplate"
          nzMode="multiple"
          class="select-multiple-no-wrap"
          [nzMaxTagCount]="5"
          [nzTooltipTitle]="labelsTooltip"
          [nzTooltipTrigger]="
            labelFormControl.value && labelFormControl.value.length >= 5
              ? 'hover'
              : null
          "
          nz-tooltip
        >
          @if (hasMixedValues.label) {
            <nz-option
              [nzValue]="'mixed'"
              [nzLabel]="'general.mixed' | translate"
              nzHide
            ></nz-option>
          }
          @for (label of labels; track label) {
            <nz-option
              [nzLabel]="label.name"
              [nzValue]="label.id"
              nzCustomContent
            >
              <span class="label-option-wrapper">
                <div
                  [style.background-color]="label.colorCode"
                  class="dot"
                ></div>
                <div class="text-truncate">
                  {{ label.name }}
                </div>
              </span>
            </nz-option>
          }
        </nz-select>
      </nz-form-control>
    </nz-form-item>
    <ng-template #selectedLabelsTemplate let-selected>
      @if (selected.nzValue === 'mixed') {
        <div class="label-option-wrapper">
          <div class="text-truncate">
            {{ 'general.mixed' | translate }}
          </div>
        </div>
      } @else {
        @let selectedLabel = selected.nzValue | getLabelById | async;
        <div class="label-option-wrapper">
          <div
            [style.background-color]="selectedLabel?.colorCode"
            class="dot"
          ></div>
          <div class="text-truncate">
            {{ selectedLabel?.name }}
          </div>
        </div>
      }
    </ng-template>
    <ng-template #labelsTooltip>
      @for (labelId of labelFormControl.value; track labelId) {
        <div class="label-option-wrapper">
          @let label = labelId | getLabelById | async;
          <div [style.background-color]="label?.colorCode" class="dot"></div>
          <div class="text-truncate">
            {{ label?.name }}
          </div>
        </div>
      }
    </ng-template>

    <!-- Status -->
    <nz-form-item>
      <nz-form-label
        class="quali-form-label"
        nzNoColon
        [nzRequired]="statusFormControl.hasValidator(Validators.required)"
      >
        {{ 'general.status' | translate }}
      </nz-form-label>
      <nz-form-control [nzValidateStatus]="statusFormControl" nzHasFeedback>
        <nz-select
          [formControl]="statusFormControl"
          [nzPlaceHolder]="
            hasMixedValues.status
              ? ('general.mixed' | translate)
              : ('general.status' | translate)
          "
          [nzCustomTemplate]="selectedStatusTemplate"
        >
          @if (currentStatusNotInFilteredOptions) {
            <nz-option
              [nzValue]="statusFormControl.value"
              [nzLabel]="statusFormControl.value"
              nzHide
              nzCustomContent
            >
              <wilson-qualification-training-status-tag
                [status]="statusFormControl.value"
              />
            </nz-option>
          }
          @for (status of filteredStatusOptions; track status) {
            <nz-option [nzLabel]="status" [nzValue]="status" nzCustomContent>
              <wilson-qualification-training-status-tag [status]="status" />
            </nz-option>
          }
        </nz-select>
      </nz-form-control>
    </nz-form-item>

    <ng-template #selectedStatusTemplate let-selected>
      <wilson-qualification-training-status-tag [status]="selected.nzValue" />
    </ng-template>
  </nz-collapse-panel>
</nz-collapse>
